module.exports = __webpack_public_path__ + "static/media/wikimedia_logo.ea9fcd69.png";